import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import FormConfirmEmail from './FormConfirmEmail'
import { Alert, Col, Form, Row, Spinner } from 'react-bootstrap'
import { checkList, fetchBlackList, isIterableArray, useClientInfo } from '../../../block-slider/utils'
import fontColorContrast from 'font-color-contrast'
import { phoneStartValueCode } from '../../../builderPage/blocks/type10/FormRegister'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input/input'
import eyeSrc from '../../../../img/eye.svg'
import eyeCloseSrc from '../../../../img/eye-close.svg'
import axios from 'axios'

const FormRegister = ({ inputsData, setIsAllowClear }) => {

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors, isValid },
    } = useForm({
        mode: 'onChange',
    })

    const {
        button_color,
        text_1, // заголовок для блока регистрации

        text_10, // заголовок для блока регистрации
        text_11, // кнопка зарегестрироваться

    } = inputsData?.setting


    const [isLoading, setIsLoading] = useState(false)
    const [isConfirmMode, setIsConfirmMode] = useState(false)
    const [confirmResendData, setConfirmResendData] = useState(null)

    const [isAlertSuccess, setIsAlertSuccess] = useState(false);
    const [isAlertError, setIsAlertError] = useState(false);
    const [textOnError, setTextOnError] = useState('');


    const [isPassword, setIsPassword] = useState(true)



    const [passwordInputData, setPasswordInputData] = useState(null)
    const [emailInputData, setEmailInputData] = useState(null)
    const [nameInputData, setNameInputData] = useState(null)
    const [surnameInputData, setSurnameInputData] = useState(null)
    const [phoneInputData, setPhoneInputData] = useState(null)
    const [checkboxInputData, setCheckboxInputData] = useState(null)

    const [blackList, setBlackList] = useState(null)
    useEffect(() => {
        fetchBlackList(11).then(res => {
            setBlackList(res)
        })
    }, [])


    useEffect(() => {
        if (isIterableArray(inputsData?.items)) {
            const passwordI = inputsData.items.find(i => i.forEmail === 'password')
            const emailI = inputsData.items.find(i => i.forEmail === 'email')
            const nameI = inputsData.items.find(i => i.forEmail === "first_name")
            const surnameI = inputsData.items.find(i => i.forEmail === "last_name")
            const phoneI = inputsData.items.find(i => i.forEmail === "phone")
            const checkboxI = inputsData.items.find(i => i.type === 1)
            if (passwordI) setPasswordInputData(passwordI)
            if (emailI) setEmailInputData(emailI)
            if (nameI) setNameInputData(nameI)
            if (surnameI) setSurnameInputData(surnameI)
            if (phoneI) setPhoneInputData(phoneI)
            if (checkboxI) setCheckboxInputData(checkboxI)
        }
    }, [inputsData])

    useEffect(() => {
        setValue('phone', phoneStartValueCode)
    }, []);

    const onSubmit = (submitData) => {
        const sendData = submitData
        delete sendData.check
        handleSend(sendData)
    }


    const { fetchClientInfo } = useClientInfo()

    const handleSend = async (sendData) => {

        const info = await fetchClientInfo()
        sendData.clientInfo = info

        setIsLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/register`, sendData)
            .then((response) => {
                if (response.data.res === 'Success') {
                    setIsConfirmMode(true)
                    setConfirmResendData(sendData)
                    setIsAllowClear(false)
                }
                if (response.data.res === 'Error') {
                    setIsAlertError(true)
                    const errText = inputsData?.setting?.[response.data?.msgKey] || 'Что-то пошло не так, попробуйте повторить позже'
                    setTextOnError(errText)
                }
            }).catch(err => {
                console.error(err.message)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <div className={`block-registration`}>
            {
                isConfirmMode ?
                    <FormConfirmEmail
                        routeToConfirm='cabinet/register'
                        data={inputsData}
                        handleResend={() => {
                            onSubmit(confirmResendData)
                        }}
                        confirmResendData={confirmResendData}
                        onConfirm={(token) => {
                            localStorage.setItem('galaxy-token', token)
                            if (window.location.pathname !== '/checkout' || window.location.pathname !== '/cart') {
                                window.location.href = '/profile'
                            } else {
                                document.location.reload();
                            }
                        }}
                    />
                    :
                    <form onSubmit={handleSubmit(onSubmit)}>


                        <div className='bg-none p-0 buildedPage-type_8-form'>
                            <div className='h5 mb-3' dangerouslySetInnerHTML={{ __html: text_10 }} />

                            {
                                isAlertSuccess &&
                                <Alert variant={'success'} onClose={() => setIsAlertSuccess(false)} dismissible>
                                    <div dangerouslySetInnerHTML={{ __html: text_10 }} />
                                </Alert>
                            }
                            {
                                isAlertError &&
                                <Alert variant={'danger'} onClose={() => {
                                    setIsAlertError(false)
                                    setTextOnError('')
                                }} dismissible>
                                    <Alert.Heading style={{ fontSize: '1.15rem' }}>Ошибка</Alert.Heading>
                                    <p className='mb-0'>{textOnError}</p>
                                </Alert>
                            }
                            <Row className='mt-4'>
                                {
                                    nameInputData &&
                                    <Col md={12} className='mb-2'>
                                        <div>
                                            <Form.Control
                                                className='mb-0'
                                                placeholder={nameInputData.text}
                                                type="text"
                                                {...register(nameInputData.forEmail, {
                                                    required: nameInputData.required,
                                                })}
                                            />
                                            <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                                <>
                                                    {
                                                        errors?.[nameInputData.forEmail]?.type === 'required' &&
                                                        'Обязательно к заполнению'
                                                    }
                                                </>
                                            </Form.Control.Feedback>
                                        </div>
                                    </Col>
                                }
                                {
                                    surnameInputData &&
                                    <Col md={12} className='mb-2'>
                                        <div>
                                            <Form.Control
                                                className='mb-0'
                                                placeholder={surnameInputData.text}
                                                type="text"
                                                {...register(surnameInputData.forEmail, {
                                                    required: surnameInputData.required,
                                                })}
                                            />
                                            <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                                <>
                                                    {
                                                        errors?.[surnameInputData.forEmail]?.type === 'required' &&
                                                        'Обязательно к заполнению'
                                                    }
                                                </>
                                            </Form.Control.Feedback>
                                        </div>
                                    </Col>
                                }
                                {
                                    emailInputData &&
                                    <Col md={12} className='mb-2' >
                                        <Form.Control
                                            className='mb-0'
                                            placeholder={emailInputData.text}
                                            type="email"
                                            {...register(emailInputData.forEmail, {
                                                required: emailInputData.required,
                                                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                validate: (value) => {
                                                    return !checkList(blackList, value)
                                                },
                                            })}
                                        />
                                        {
                                            <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                                {
                                                    errors?.[emailInputData.forEmail]?.type === 'required' &&
                                                    'Обязательно к заполнению'
                                                }
                                                {
                                                    errors?.[emailInputData.forEmail]?.type === 'pattern' &&
                                                    'E-mail заполнен некорректно '
                                                }
                                                {
                                                    errors?.[emailInputData.forEmail]?.type === "validate" &&
                                                    (blackList?.text || "Недопустимое значение E-mail")
                                                }
                                            </Form.Control.Feedback>
                                        }
                                    </Col>
                                }
                                {
                                    passwordInputData &&
                                    <Col md={12} className='mb-2'>
                                        <div>
                                            <div style={{ position: 'relative' }}>
                                                <Form.Control
                                                    className='mb-0'
                                                    placeholder={passwordInputData.text}
                                                    type={isPassword ? "password" : 'text'}
                                                    {...register(passwordInputData.forEmail, {
                                                        required: !!passwordInputData.required,
                                                        minLength: 8,
                                                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
                                                    })}
                                                />
                                                <div
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '6px 12px',
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 0,
                                                    }}
                                                    onClick={() => setIsPassword(prev => !prev)}
                                                >
                                                    {
                                                        isPassword ?
                                                            <img src={eyeSrc} style={{ width: 30, height: 22 }} alt="Eye" />
                                                            :
                                                            <img src={eyeCloseSrc} style={{ width: 30, height: 22 }} alt="Eye" />
                                                    }
                                                </div>
                                            </div>
                                            <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                                {
                                                    errors[passwordInputData.forEmail]?.type === 'minLength' &&
                                                    "Пароль должен содержать минимум 8 символов"
                                                }
                                                {
                                                    errors[passwordInputData.forEmail]?.type === 'pattern' &&
                                                    "Пароль обязательно должен содержать символы, цифры и заглавные и строчные латинские буквы"
                                                }
                                                {
                                                    errors[passwordInputData.forEmail]?.type === 'required' &&
                                                    "Обязательно к заполнению"
                                                }
                                            </Form.Control.Feedback>
                                        </div>
                                    </Col>
                                }
                                {
                                    phoneInputData &&
                                    <Col md={12} className='mb-2'>
                                        <Controller
                                            name={phoneInputData.forEmail}
                                            control={control}
                                            rules={{
                                                validate: (value) => isValidPhoneNumber(value || ''),
                                                required: phoneInputData.requiredƒ
                                            }}
                                            render={({ field }) => (
                                                <PhoneInput
                                                    {...field}
                                                    className='form-control mb-0'
                                                    id={phoneInputData.forEmail}
                                                    placeholder={phoneInputData.text}
                                                    onChange={(e) => {
                                                        setValue(phoneInputData.forEmail, e ? e : phoneStartValueCode)
                                                    }}
                                                    type='tel'
                                                    autoComplete="tel"
                                                />
                                            )}
                                        />
                                        <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                            {errors[phoneInputData.forEmail]?.type === 'validate' && 'Телефон заполнен некорректно'}
                                            {errors[phoneInputData.forEmail]?.type === 'required' && "Телефон обязателен к заполнению "}
                                        </Form.Control.Feedback>
                                    </Col>
                                }
                            </Row>
                            <hr />
                            <Row className='mt-3'>
                                <Col md={12}>
                                    {
                                        checkboxInputData &&
                                        <div className='mb-2'>
                                            <Form.Check
                                                className='d-inline-block'
                                                type="checkbox"
                                                label={<span dangerouslySetInnerHTML={{ __html: checkboxInputData.text }} />}
                                                id={'check'}
                                                {...register('check', { required: true })}
                                            />
                                            {
                                                errors.check &&
                                                <Form.Control.Feedback type="invalid" className='d-block'>
                                                    Обязательно к заполнению
                                                </Form.Control.Feedback>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col md={12} >
                                    <button
                                        disabled={!isValid}
                                        className='btn btn-submit'
                                        // type='submit'
                                        style={{
                                            backgroundColor: button_color,
                                            color: fontColorContrast(button_color)
                                        }}
                                    >
                                        {
                                            isLoading ?
                                                <Spinner animation='border' />
                                                :
                                                <div dangerouslySetInnerHTML={{ __html: text_11 || 'Отправить' }}></div>
                                        }
                                    </button>

                                    {
                                        text_1 &&
                                        <div className='text_under mt-3' dangerouslySetInnerHTML={{ __html: text_1 }} />
                                    }
                                </Col>
                            </Row>
                        </div>
                    </form>
            }
        </div>
    )
}


export default FormRegister